import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const CompanyOrganizationalAndLegalFormSection = (formProps: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="companyOrganizationalAndLegalFormSection"
      title={t('client.legal.organizationalAndLegalForm.title')}
    >
      <FormContent {...formProps} />
    </Section>
  );
};
